import Matter from 'matter-js'
import { MainProduct } from '../../types/index'
import { createChainBody, createPendant, DEVICE_PIXEL_RATIO } from './index'
import { createNewConstraint } from './create-new-constraint'
import { getMainProductVariantById } from '..'

const HORIZONTAL_INDENT = 150 * DEVICE_PIXEL_RATIO;

export const renderNecklace = (
  engine: Matter.Engine,
  render: Matter.Render,
  mainProduct: MainProduct,
  activeMainProductVariantId: string,
  activePendantProductVariants: string[]
) => {
  Matter.World.clear(engine.world, true)

  const mainProductVariant = getMainProductVariantById(mainProduct, activeMainProductVariantId)
  const length = mainProductVariant.metafields.builderData.numberOfChains
  const sprites = mainProductVariant.metafields.builderData.sprites
  const textures = mainProductVariant.textureUrls

  const chains = Array.from({ length }).map((_, index) => {
    const spriteIndex = index % sprites.length
    const sprite = sprites[spriteIndex]

    const x = (HORIZONTAL_INDENT + ((render.canvas.width - 2 * HORIZONTAL_INDENT) * index / length)) / DEVICE_PIXEL_RATIO 
    const y = 0

    const width =  sprite.width
    const height = sprite.height
    const texture = textures[spriteIndex]
    const label = `chain/${spriteIndex}`

    return createChainBody(x, y, width, height, texture, label)
  })

  const pendants = activePendantProductVariants.map((pendant, index) => { 
    const relativeCanvasWidth = render.canvas.width / DEVICE_PIXEL_RATIO
    const relativeHorizontalIndent = HORIZONTAL_INDENT / DEVICE_PIXEL_RATIO

    // @TODO: Migrate to relative units
    const x = relativeHorizontalIndent + (index + 1) * (relativeCanvasWidth - 2 * relativeHorizontalIndent) / (activePendantProductVariants.length + 1)
    const y = 0

    return createPendant(x, y, mainProduct.metafields.pendantProducts, pendant, mainProduct)
  })

  const chainsAndPendantsLength = chains.length + pendants.length
  const pendantPositionStep = Math.ceil(chains.length / (pendants.length + 1))
  const chainsAndPendants: Matter.Body[] = []

  const chainLength = chains.length
  for (let i = 0; i < chainLength; i++) {    
    const isPendantPosition = (i + 1) % (pendantPositionStep) === 0

    // @TODO: find a way to escape pendants.length > 0 condition
    // One temporal solution is to add pendants.length > 0
    // 130 % 2 === 0 for 65 and 130. 
    if (isPendantPosition && pendants.length > 0) {
      chainsAndPendants.push(pendants.shift()!)
    }

    chainsAndPendants.push(chains.shift()!) 
  }

  const constraints = Array.from({ length: chainsAndPendantsLength - 1 }).map((_, i) => {      
    const bodyA = chainsAndPendants[i]
    const bodyB = chainsAndPendants[i + 1]
    
    return createNewConstraint(bodyA, bodyB, mainProduct, activeMainProductVariantId)
  })

  chainsAndPendants.forEach(b => b.collisionFilter.group = -1)

  const necklace = [
    ...chainsAndPendants,
    ...constraints,
  ]

  chainsAndPendants[0].isStatic = true
  chainsAndPendants[chainsAndPendants.length - 1].isStatic = true

  Matter.Composite.add(engine.world, necklace);

  engine.enabled = true
}